import { useSelector } from 'react-redux'

import { InfoBlock, InfoBlockType } from 'cng-common/components/infoBlock'
import { getFormatDate } from 'core/classes/helpers/DateHelper'

import { MARKET_YOY_GROWTH_EXPECTATION_TRANSLATION_KEYS } from '../../configs/translations'
import {
  selectMarketYoyGrowthExpectationPlanning,
  selectMarketYoyGrowthExpectationsWorkflowState,
} from '../../model'

const KEYS = MARKET_YOY_GROWTH_EXPECTATION_TRANSLATION_KEYS

export const MarketYoyGrowthExpectationBanner = () => {
  const workflowState = useSelector(selectMarketYoyGrowthExpectationsWorkflowState)
  const planning = useSelector(selectMarketYoyGrowthExpectationPlanning)

  if (workflowState === 'published') {
    return (
      <InfoBlock
        type={InfoBlockType.Success}
        text={KEYS.banner.published}
        replaceParams={[
          {
            key: '{date}',
            value: planning?.modified ? (getFormatDate(planning.modified, 'date4') ?? '') : '',
          },
        ]}
      />
    )
  }

  if (workflowState === 'locked') {
    return (
      <InfoBlock
        type={InfoBlockType.Danger}
        text={KEYS.banner.locked}
        replaceParams={[{ key: '{fYear}', value: planning?.fYear ? String(planning.fYear) : '' }]}
      />
    )
  }

  return null
}

MarketYoyGrowthExpectationBanner.displayName = 'MarketYoyGrowthExpectationBanner'
